import React, { Component } from 'react';
import axios from 'axios';

require(`../assets/${process.env.PAGE}/css/components/camera.css`);

import { getRandomNumber, shuffle } from '../utils/utils';

import RenaperStepErrorMessage from './RenaperStepErrorMessage';

import SelfieCamera from './SelfieCamera';
import CustomSpinner from './CustomSpinner.js';


const SELFIE_TYPES = [
  {
    type:"SN",
    description: "Poné tu rostro neutral",
    icon: require(`../assets/common/renaper/sn.png`),
    successIcon: require(`../assets/common/renaper/sn-ok.png`),
  },
  {
    type: "SS",
    description: "Sonreí",
    icon: require(`../assets/common/renaper/ss.png`),
    successIcon: require(`../assets/common/renaper/ss-ok.png`),
  },
  {
    type: "SBL",
    description: "Guiñá tu ojo izquierdo",
    icon: require(`../assets/common/renaper/sbl.png`),
    successIcon: require(`../assets/common/renaper/sbl-ok.png`),
  },
  {
    type: "SBR",
    description: "Guiñá tu ojo derecho",
    icon: require(`../assets/common/renaper/sbr.png`),
    successIcon: require(`../assets/common/renaper/sbr-ok.png`),
  },
];

class RenaperRegister extends Component {
  constructor(props){
    super(props);

    this.state = {
        files: [],
        currentType: null,
        lastType: false,
        selfiesTypes: [],
        play: false,
        loading: false,
        browserFingerPrint: null,
        stepError: false,
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setBrowserFingerPrint = this.setBrowserFingerPrint.bind(this);
  }

  componentDidMount(){
    const selfiesTypes = this.getSelfiesTypesByIndex()

    this.setState({
        currentType: selfiesTypes.pop(),
        selfiesTypes,
    });
    var vuFp = new window.VUBrowserFP();
    vuFp.getFingerprintInfoWithSeed(this.setBrowserFingerPrint);
  }

  handleChange(file){
    const { currentType, selfiesTypes, files, browserFingerPrint } = this.state;

    files.push({
      imageType: currentType.type,
      file: file
    });

    this.setState({
      ...this.state,
      files: files,
    });

    if(selfiesTypes.length === 1){
      this.setState({
        lastType: true
      })
    }

    if(selfiesTypes.length === 0){
      this.setState({
        ...this.state,
        loading: true,
      });
      const ROOT_URL = process.env.API_URL;

      const config = {
          headers:
              {
                  'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
                  'Content-Type': 'multipart/form-data'
              }
      };

      const formData = new FormData();

      formData.append('renaper_browser_fingerprint', browserFingerPrint)

      files.forEach((selfie) => {
        formData.append(selfie.imageType, selfie.file)
      });

      axios.post(`${ROOT_URL}/identity/renaper/register`, formData, config)
      .then((response)=> {
        this.props.onFinish();
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          stepError: true
        })
        setTimeout(this.props.onRollback, 5 * 1000);
      });

    }else {
      this.setState({
        ...this.state,
        currentType: selfiesTypes.pop(),
        selfiesTypes: selfiesTypes
      });
    }

  }

  handleClick(event){
    event.preventDefault();

    this.setState({
      ...this.state,
      play: true
    });
  }

  getSelfiesTypesByIndex(){
    let selectedSelfiesTypesByIndex = [0];
    for(var i = 0; i < 2; i ++){
      let randomIndex = null;
      do {
        randomIndex = getRandomNumber(1 ,4, true);
      }
      while(selectedSelfiesTypesByIndex.includes(randomIndex))
      selectedSelfiesTypesByIndex.push(randomIndex);
    }
    return shuffle(selectedSelfiesTypesByIndex
                   .map(index => SELFIE_TYPES[index]));
  }

  setBrowserFingerPrint(browserInfo){
    const { form } = this.state;

    var result =  browserInfo.fingerprint; //Información a enviar al server en Base64
    this.setState({
      ...this.state,
      browserFingerPrint: result
    })
  }

  render() {
    const { currentType, lastType, play, loading, stepError } = this.state;

    const startButton = (
      <div style={{
        textAlign: "center",
      }}>
        <h4 style={{
          color: "#fff"
        }}>
          Colocá tu rostro en el círculo y pulsá el botón comenzar
        </h4>
        <button
          onClick={this.handleClick}
          className='btn btn-primary btn-lg action-button'>
            Comenzar
        </button>
      </div>
    );

    const errorMessage = (<RenaperStepErrorMessage/>);

    return (
      <div style={{
        position: "fixed",
        left: 0,
        top: 0,
        height: "100%",
        width: "100%",
        background: "#000",
      }} >
        {loading && <CustomSpinner message={ stepError ? errorMessage : 'Estamos analizando los datos. Por favor espere...' } />}
        <SelfieCamera
          play={play}
          fileType={currentType}
          lastType={lastType}
          onChange={this.handleChange}
          onStart={this.handleClick}
          interval={10}
          shapeStyle={{
              aspectRatio: 1,
              defaultFixedSide: 'height',
              borderRadius: '50%',
              captureOptions: {
                  audio: false,
                  video: true
              }
          }}/>
        { !play && startButton }
      </div>)

  }
}
module.exports = RenaperRegister


/** WEBPACK FOOTER **
 ** ./src/components/RenaperRegister.js
 **/